/* Built In Imports */
/* External Imports */
import { Box, Skeleton } from '@chakra-ui/react';
import { Suspense } from 'react';

/* Internal Imports */
/* Components */
/* Services */

/**
 * Renders the Mid Container component
 *
 * @param {object} props - Layout Props
 * @param props.w
 * @param props.mx
 * @param props.my
 * @param props.px
 * @param props.children
 * @returns {ReactElement} Mid Container component
 */
const MidContainer = ({ w, mx, my, px, children, ...props }) => {
  return (
    <Box
      as="section"
      w={{ base: '100%' }}
      maxW={w || '944px'}
      mx={mx || 'auto'}
      my={my}
      className="embedBox"
      px={px}
      {...props}
      marginInlineStart="auto"
      marginInlineEnd="auto"
    >
      <Suspense fallback={<Skeleton />}>{children}</Suspense>
    </Box>
  );
};
export default MidContainer;
